import React, { ElementType, PropsWithChildren } from 'react'

import { bemJoin, classNames } from '@app/lib/bem'
import { PolymorphicComponentProps } from '@app/lib/types'

import './Text.scss'

export type TextProps<T extends ElementType> = PolymorphicComponentProps<
  T,
  {
    size?: 'sm' | 'md' | 'ml' | 'lg' | 'xl' | '2xl'
    color?: 'primary' | 'secondary' | 'danger' | 'success' | 'black' | 'neutral' | 'white'
    weight?: 'normal' | 'bolder' | 'bold'
    serif?: 'sans-serif' | 'serif' | 'monospace'
    justification?: 'left' | 'center' | 'right'
  }
>

const b = bemJoin('lawyer-text')

export const Text = <T extends ElementType>({
  as,
  children,
  className,
  weight = 'normal',
  size = 'md',
  color = 'black',
  serif = 'sans-serif',
  justification = 'left',
  ...rest
}: PropsWithChildren<TextProps<T>>) => {
  const Component = as || 'div'

  return (
    <Component
      className={classNames(
        b({
          [weight]: true,
          [size]: true,
          [color]: true,
          [serif]: true,
          [justification]: true
        }),
        className
      )}
      {...rest}
    >
      {children}
    </Component>
  )
}
